export default __webpack_public_path__ + "static/media/045-golf.8e27041d.svg";